import { Clock } from "lucide-react";
import clsx from "@/lib/clsx";

interface Props {
  questionRemainingSec: number;
  questionLimitSec: number;
  totalRemainingSec: number;
}

export default function GameTimer({ questionRemainingSec, questionLimitSec, totalRemainingSec }: Props) {
  const pct = Math.max(0, Math.min(100, (questionRemainingSec / questionLimitSec) * 100));
  const warning = questionRemainingSec <= 10;

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between text-sm">
        <span className={clsx("flex items-center gap-1", warning && "text-rose-400 animate-pulse-soft")}>
          <Clock className="w-4 h-4" />
          {questionRemainingSec}s for this question
        </span>
        <span className="text-steel-300">Total left: {fmt(totalRemainingSec)}</span>
      </div>
      <div className="h-2 rounded-full bg-steel-800 overflow-hidden">
        <div
          className={clsx(
            "h-full transition-[width] duration-300",
            warning ? "bg-rose-500" : "bg-forge-500"
          )}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}

function fmt(sec: number): string {
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
}
